import { Component, OnInit } from '@angular/core';
import { ReactionHubService } from './services/reaction-hub.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    title = 'Truth Shorts';

    constructor(private reactionHub: ReactionHubService) {}

    ngOnInit(): void {
        this.reactionHub.start();
    }
}
